import { useCallback } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Link from 'fe-design-base/molecules/Link';

import { openCSChat } from 'util/csChat';
import { toI18n } from 'util/i18n';

export const ChatSupportLink = () => {
  const handleClickChatWithUs = useCallback(() => {
    openCSChat();
  }, []);

  return (
    <Box hcenter row gap={8}>
      <Text i18n="authentication.sierra_chat_text" />
      <Link onClick={handleClickChatWithUs} uxElement="chat support link">
        {toI18n('authentication.sierra_chat_link_alt')}
      </Link>
    </Box>
  );
};

export default ChatSupportLink;
